module.exports = __webpack_public_path__ + "static/client_7-8ad25f1f5ef7f9696b767319f22b1845.png";